const firebaseConfig = {
    apiKey: "AIzaSyCP_PjGS7V7kpwlVj9dtriGJsk2g8UmOtQ",
    authDomain: "crewcoin-3d719.firebaseapp.com",
    projectId: "crewcoin-3d719",
    storageBucket: "crewcoin-3d719.appspot.com",
    messagingSenderId: "842902059187",
    appId: "1:842902059187:web:9584a2da2e10b078a798c6"
  };

  export default firebaseConfig;